import { CB_VIEWBOX, CB_PATHS } from './brandVector'

/**
 * CreepMark — ВЕКТОРНАЯ квадратная иконка "cb▮" (Erbaum Black).
 *
 * Контуры "cb" + каретка из brandVector.ts. Группа вписывается по центру
 * квадрата с полями (preserveAspectRatio meet) — не обрезается.
 * Тёмный скруглённый квадрат, "cb" светлые, каретка — цвет темы.
 */
interface CreepMarkProps {
  size?: number
  className?: string
}

export function CreepMark({ size = 36, className = '' }: CreepMarkProps) {
  const inner = size * 0.78 // зона для глифов внутри квадрата (поля ~11%)
  return (
    <span
      className={className}
      style={{
        width: size,
        height: size,
        background: '#0B0B0C',
        borderRadius: size * 0.29,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        flexShrink: 0,
      }}
      aria-label="creepbrowser"
    >
      <svg
        width={inner}
        height={inner}
        viewBox={CB_VIEWBOX}
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        style={{ display: 'block' }}
      >
        {CB_PATHS.map((p, i) => (
          <path
            key={i}
            d={p.d}
            transform={`translate(${p.tx},${p.ty})`}
            fill={p.c === 'caret' ? 'var(--primary)' : '#F5F5F5'}
          />
        ))}
      </svg>
    </span>
  )
}

export default CreepMark
